import './client-table.css';
import { useMemo, useRef } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { InfiniteVirtualTable } from '@nesso/ui/blocks/table/infinite-virtual-table';
import { VirtualTableLoadingRow } from '@nesso/ui/blocks/table/virtual-table-loading-row';

import { clientListOptions } from '@/entities/client';
import { DataSpinner } from '@/shared/ui/indicators/data-spinner';

import { clientTableColumns } from './client-table/client-table-columns';
import { ClientTableSkeleton } from './client-table/client-table-skeleton';

export function ClientTable() {
    const tableContainerRef = useRef<HTMLDivElement>(null);

    const infiniteQuery = useInfiniteQuery(clientListOptions());

    const clients = useMemo(
        () => infiniteQuery.data?.pages?.flatMap((page) => page.items) ?? [],
        [infiniteQuery.data],
    );

    const table = useReactTable({
        data: clients,
        columns: clientTableColumns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <InfiniteVirtualTable
            {...infiniteQuery}
            table={table}
            rows={table.getRowModel().rows}
            scrollContainerRef={tableContainerRef}
            loadingRow={
                <VirtualTableLoadingRow
                    colSpan={clientTableColumns.length}
                    spinner={<DataSpinner />}
                    rowClassName="table-row"
                    cellClassName="table-cell py-4 text-center"
                />
            }
            skeleton={<ClientTableSkeleton />}
            emptyMessage="No results found"
            className="flex-1 overflow-auto client-table-grid"
        />
    );
}
